<div class="top-control-container">

  <div class="top-left-container">
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Results:
        <span class="ml-3" [class.no-results]="results.data.length === 0">
          {{ results.data.length | number }}
        </span>
      }
    </div>

    @if(!isMobile) {
      <button mat-icon-button (click)="runSearch(true, true)" matTooltip="Refresh" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
      </button>
    }

  </div>

  @if (!isMobile) {
    <div class="filters-container">
      <mat-chip-set>
        @for (chip of filterChips; track chip.key) {
          <mat-chip-row
            (click)="chip.action()"
            [removable]="chip.removable"
            (removed)="removeFilter(chip.key)"
          >
            {{ chip.label }}

            @if (chip.removable) {
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-chip-row>
        }
      </mat-chip-set>

      <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Add Filter">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (availableFilter of availableFilters; track availableFilter.key) {
          <button mat-menu-item (click)="addFilter(availableFilter.key)">
            {{ availableFilter.label }}
          </button>
        }
      </mat-menu>
    </div>
  }

  <div class="top-right-container">

      @if(!isMobile) {
        <button mat-stroked-button (click)="updateSearch()" [disabled]="loading">
          Filters
        </button>
      } @else {

        <button
          mat-icon-button
          (click)="goBack()"
          matTooltip="Back"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>

        <button mat-icon-button (click)="runSearch(true, true)" matTooltip="Refresh" [disabled]="loading">
          <mat-icon>refresh</mat-icon>
        </button>

        <button
          mat-icon-button
          (click)="updateSearch()"
          [disabled]="loading"
          matTooltip="Filters"
        >
          <mat-icon>filter_list</mat-icon>
        </button>

        <button
          mat-icon-button
          [matMenuTriggerFor]="sortMenu"
          matTooltip="Sort"
          type="button"
        >
          <mat-icon>sort</mat-icon>
        </button>

        <mat-menu #sortMenu="matMenu">

          <button mat-menu-item type="button" (click)="sortBy('refreshed_at', 'desc')">
            <mat-icon>schedule</mat-icon>
            <span>Newest</span>
          </button>

          <button mat-menu-item type="button" (click)="sortBy('origin_deadhead_distance', 'asc')">
            <mat-icon>near_me</mat-icon>
            <span>Deadhead: Low to High</span>
          </button>

          <button mat-menu-item type="button" (click)="sortBy('axle_count', 'desc')">
            <mat-icon>format_list_numbered</mat-icon>
            <span>Axles: High to Low</span>
          </button>

          <button mat-menu-item type="button" (click)="sortBy('well_length', 'desc')">
            <mat-icon>straighten</mat-icon>
            <span>Well: High to Low</span>
          </button>

          <button mat-menu-item type="button" (click)="sortBy('max_weight', 'desc')">
            <mat-icon>scale</mat-icon>
            <span>Max Weight: High to Low</span>
          </button>

          <mat-divider></mat-divider>

          <button mat-menu-item type="button" (click)="clearSort()">
            <mat-icon>clear</mat-icon>
            <span>Clear Sort</span>
          </button>

        </mat-menu>
      }

    </div>

</div>

<table
  mat-table
  [dataSource]="results"
  matSort
  class="results-table"
>

  <!-- Mobile Column -->
  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let truck">
      <div class="mobile-load-cell">

        <button
          mat-icon-button
          class="mobile-save-button"
          (click)="toggleSavedTruck(truck); $event.stopPropagation()"
        >
          <mat-icon [class.saved]="truck.is_saved">
            {{ truck.is_saved ? 'favorite' : 'favorite_border' }}
          </mat-icon>
        </button>

        <div class="mobile-location-row">
          <mat-icon class="mobile-map-icon">location_on</mat-icon>

          <div class="location-text">
            {{ truck.origin_city | titlecase }}, {{ truck.origin_state }}

            @if (truck.origin_deadhead_distance) {
              <span class="deadhead-distance">
                ({{ truck.origin_deadhead_distance }} mi)
              </span>
            }
          </div>
        </div>

        <div class="mobile-details">
          Available:
          @if (truck.available_start_date === truck.available_end_date) {
            {{ truck.available_start_date | date:'MM/dd' }}
          } @else {
            {{ truck.available_start_date | date:'MM/dd' }} -
            {{ truck.available_end_date | date:'MM/dd' }}
          }
        </div>

        <div class="mobile-details">
          Max Weight: {{ truck.max_weight | number }} lbs
        </div>

        <div class="mobile-details">
          Axles: {{ truck.axle_count }}
        </div>

        <div class="mobile-details">
          Well: {{ toFeetAndInches(truck.well_length) }}
        </div>

        <div class="mobile-details">
          {{ truck.carrier_name }}
        </div>

        <div class="mobile-details">
          Base: {{ truck.carrier_base_state }}
        </div>

        <div class="mobile-details">
          Age: {{ formatAge(truck.refreshed_since) }}
        </div>

      </div>
    </td>
  </ng-container>

  <!-- Desktop Columns -->
  <ng-container matColumnDef="is_saved">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Saved</th>

    <td mat-cell *matCellDef="let truck">
      <button mat-icon-button (click)="toggleSavedTruck(truck); $event.stopPropagation()">
        <mat-icon [class.saved]="truck.is_saved">
          {{ truck.is_saved ? 'favorite' : 'favorite_border' }}
        </mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Age
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ formatAge(truck.refreshed_since) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_deadhead_distance">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      O-DH
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.origin_deadhead_distance }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Origin
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.origin_city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      ST
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.origin_state }}
    </td>
  </ng-container>

  <ng-container matColumnDef="available_dates">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Dates
    </th>
    <td mat-cell *matCellDef="let truck">
      @if(truck.available_start_date === truck.available_end_date) {
        {{ truck.available_start_date | date: 'MM/dd' }}
      } @else {
        {{ truck.available_start_date | date: 'MM/dd' }} -
        {{ truck.available_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="max_weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Max Weight
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.max_weight | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="axle_count">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Axles
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.axle_count }}
    </td>
  </ng-container>

  <ng-container matColumnDef="well_length">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Well Length
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ toFeetAndInches(truck.well_length) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Carrier
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.carrier_name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier_base_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Carrier Home Base State">
      Base
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.carrier_base_state }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" [hidden]="results.data.length === 0"></tr>

  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [class.new-row]="isFresh(row)"
    (click)="viewTruckDetails(row)"
    class="clickable-row"
  ></tr>

  <tr class="mat-row" *matNoDataRow>
    <td
      class="no-results-cell"
      [attr.colspan]="displayedColumns.length"
    >
      @if (loading) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else {
        <div class="yellow-container">
          No trucks found. Try adjusting your filters or refreshing the search.
        </div>
      }
    </td>
  </tr>
  
</table>

<br />

<mat-paginator
  [style.display]="results.data.length === 0 ? 'none' : ''"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="[10, 25, 50, 100]"
  showFirstLastButtons
></mat-paginator>